import React from 'react';
import { UsersIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
export function KeyHighlights() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1526">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1527">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1528">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1529">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1530">
              <UsersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1531" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1532">
              Class Size: 6–12
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1533">
              Minimum 6 students, maximum 12 students per class for personalized
              instruction.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1534">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1535">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1536" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1537">
              4 Hours
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1538">
              Includes both classroom instruction and range time learning to
              shoot.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1539">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-1540">
              <DollarSignIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-1541" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-1542">
              Cost: $65
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1543">
              Same price for both FLSC members and non-members.
            </p>
          </div>
        </div>
      </div>
    </div>;
}